import { Icon } from "@iconify/react";
import { Stack, Typography, useTheme } from "@mui/material";

import { Strings } from "@app/constants";

const SellingTime = ({ methods }: any) => {
  const theme = useTheme();
  const selectedSellingTime = methods.watch("selectedSellingTime");
  const data = [
    {
      icon: "carbon:time",
      heading: "Immediately",
      subHeading: "Sell within a few days",
    },
    {
      icon: "carbon:time",
      heading: "Within 1 month",
      subHeading: "Sell in the coming month",
    },
    {
      icon: "carbon:time",
      heading: "Later",
      subHeading: "Just checking the price",
    },
  ];

  return (
    <>
      <Stack flexDirection={"column"} py={2}>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {Strings.step.sellingTime.whenWouldYouLike}
          </Typography>
          <Typography variant="body1" sx={{ color: theme.palette.grey[500] }}>
            {Strings.step.sellingTime.chooseYourPreferredTimeline}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{
          mt: { xs: 3, sm: 5 },
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {data?.map((item, index) => (
          <Stack
            key={index}
            onClick={() =>
              methods.setValue("selectedSellingTime", item.heading, {
                shouldValidate: true,
              })
            }
            sx={{
              px: { xs: 5, sm: 7 },
              py: 2,
              minWidth: 280,
              border: 1,
              borderRadius: 2,
              cursor: "pointer",
              borderColor:
                selectedSellingTime === item.heading
                  ? theme.palette.primary.main
                  : theme.palette.common.black,
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Icon
              icon={item.icon}
              fontSize={38}
              color={
                selectedSellingTime === item.heading
                  ? theme.palette.primary.main
                  : theme.palette.common.black
              }
            />
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: 18,
                color:
                  selectedSellingTime === item.heading
                    ? theme.palette.primary.main
                    : theme.palette.grey[900],
              }}
            >
              {item.heading}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 400,
                color:
                  selectedSellingTime === item.heading
                    ? theme.palette.primary.main
                    : theme.palette.grey[700],
              }}
            >
              {item.subHeading}
            </Typography>
          </Stack>
        ))}
      </Stack>
      {methods.formState.errors?.selectedSellingTime && (
        <Typography color="error" textAlign="center" mt={2} fontWeight={600}>
          {methods.formState.errors.selectedSellingTime.message}
        </Typography>
      )}
    </>
  );
};

export { SellingTime };
